import { render, staticRenderFns } from "./PurchaseChartDataSettings.vue?vue&type=template&id=10005caf&scoped=true"
import script from "./PurchaseChartDataSettings.vue?vue&type=script&lang=ts"
export * from "./PurchaseChartDataSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10005caf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10005caf')) {
      api.createRecord('10005caf', component.options)
    } else {
      api.reload('10005caf', component.options)
    }
    module.hot.accept("./PurchaseChartDataSettings.vue?vue&type=template&id=10005caf&scoped=true", function () {
      api.rerender('10005caf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/PurchaseChartDataSettings.vue"
export default component.exports